/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { DataProvider, IErrorModel, useDataLoader } from "@nf/common";

export const useValidatePinCode = (pinCodeId?: string, pinCode?: string) => {
  return useDataLoader<boolean, IErrorModel | undefined>({
    loader: () => {
      if (!pinCode || !pinCodeId) {
        return Promise.resolve({
          ok: false,
          error: undefined,
        });
      }

      return DataProvider.validateUserSubprofilePinCode(pinCodeId, pinCode)
        .then((data) => {
          return {
            ok: true,
            data,
            error: undefined,
          };
        })
        .catch((response) => {
          return {
            ok: false,
            error: response.Message,
          };
        });
    },
    deps: [pinCodeId],
  });
};
